module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-content-wrapper"
  }, [_c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3ec79e","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/page/PageBody.vue
// module id = 1101
// module chunks = 4 5 35